"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./src/localize-router.module"));
__export(require("./src/localize-router.parser"));
__export(require("./src/localize-router.service"));
__export(require("./src/localize-router.pipe"));
__export(require("./src/localize-router.config"));
__export(require("./src/localize-router-config-loader"));



//////////////////
// WEBPACK FOOTER
// ./node_modules/localize-router/index.js
// module id = 63
// module chunks = 0